import {Ministry} from '../../../../../profile/domain/ministry/ministry';
import {DynSelectFieldOptions} from './dyn-select-field-options';


export class DynSelectFieldOptionsMinistry
    extends DynSelectFieldOptions<Ministry> {

    getValueAsString(value: Ministry): string {
        return value.name + ' (' + value.address.street + ', ' + value.address.city.name + ')';
    }

/*
    public static createFromObject(object: Object): DynSelectFieldOptionsMinistry {
        const sfo = new DynSelectFieldOptionsMinistry();
        sfo.updateFromObject(object);
        return sfo;
    }

    protected updateFromObject(object: Object) {
        super.updateFromObject(object);
        this.options = object['options'].map(ministry => new Ministry(ministry));
    }
*/

}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/fields/select/dyn-select-field-options-ministry.ts